{
  "ageGate": {
    "back": "Atrás",
    "country": "País",
    "day": "Día",
    "description": "{0} Inicia sesión o confirma tu edad y ubicación para continuar.",
    "enter": "Entrar",
    "intro": "Bienvenido a LeafLink!",
    "leave": "Leave",
    "month": "Mes",
    "notOfAge": "Lo sentimos, pero no tienes edad suficiente para acceder a esta página.",
    "overAge": "¿Tiene más de 21 años de edad?",
    "privacyPolicy": "Política de Privacidad",
    "province": "Provincia",
    "termsOfUse": "Términos de uso",
    "title": "Verificación de edad",
    "usageAgreement": "Al ingresar a este sitio usted acepta nuestros {0} y {1}.",
    "year": "Año"
  },
  "brand_menu": {
    "addToCart": "Añadir a la cesta",
    "addToCartError": "Hubo problema agregando sus productos a la canasta! <br /> Por favor verifique los errores mostrados abajo.",
    "addToCartErrorCount": "0 elementos con errores | {count} elemento con errores | {count} elementos con errores",
    "addToCartSuccessCount": "0 productos añadidos correctamente | {count} elemento añadido con éxito | {count} elementos añadidos correctamente",
    "amountOffPerCase": "{amount} descontado por caja",
    "amountOffPerUnit": "{amount} descontado por unidad",
    "batchesResults": "Lotes y resultados de las pruebas",
    "brandAsc": "Marca (asc)",
    "brandBanner": "Banner Marca",
    "brandDesc": "Marca (desc)",
    "brandLogo": "Logotipo Marca",
    "createdDateAsc": "Fecha de Creación (asc)",
    "createdDateDesc": "Creado fecha (desc)",
    "currentSubtotal": "Subtotal de la cesta actual",
    "exportMenu": "Exportar menu",
    "learnMore": "¿Quieres saber más acerca de los productos de la empresa {company}?",
    "letThemKnow": "Hagales saber",
    "messageBrand": "Mensaje {brand}",
    "messageSucess": "Mensaje enviado",
    "moreFromSeller": "Más de este Vendedor",
    "newSubtotal": "Subtotal de carrito nuevo",
    "nextProduct": "Siguiente producto",
    "previousProduct": "producto anterior",
    "printMenu": "Menú Imprimir",
    "productDescription": "Descripción Producto",
    "productDetails": "Detalles Producto",
    "productInformation": "Información Producto",
    "selectedSubtotal": "Subtotal seleccionado",
    "takeMeBack": "Llévame de vuelta a la vieja experiencia",
    "viewProductDetail": "Ver página de detalles del producto",
    "volumeDiscounts": "Descuentos por volumen"
  },
  "brands": {
    "previewMenu": {
      "description": "Edit product order and preview your menu",
      "generalInformation": {
        "descriptionFirstParagraph": "Below is a preview of how your menu appears to retailers when they shop 1906. You can use the license type dropdown below to simulate a buyer who is shopping your products.",
        "descriptionSecondParagraph": "The areas highlighted in red are recommendations for improving your menu. These best practices are based on feedback we have received from retailers, so updating these can help make your menu more appealing to shoppers. These recommendations are only visible to you, the menu owner, and will not appear to retailers.",
        "descriptionThirdParagraph": "If you'd like additional recommendations for how to improve your menu, our Client Experience team is happy to help! Email them at support{'@'}leaflink.com.",
        "label": "Simulate shopper type",
        "title": "General Information"
      },
      "menuChecklist": {
        "descriptionFirstLine": "Do you see all the products you expect to see?",
        "descriptionFourthLine": "Are your sample requests and minimum/maximum order quantities set correctly?",
        "descriptionSecondLine": "Do all of your products have images and descriptions?",
        "descriptionThirdLine": "Are your products grouped by product line? (Recommended for long menus with many SKUs)",
        "title": "Menu Checklist"
      },
      "title": "Preview Menu"
    }
  },
  "common": {
    "about": "Acerca de",
    "acceptInvite": "Aceptar invitación",
    "action": "Acción",
    "actions": "Acciones",
    "active": "Activo",
    "add": "Añadir",
    "added": "Añadida",
    "address": "Dirección",
    "adjust": "Ajustar",
    "agreeToTerms": "Debes aceptar los términos y condiciones para continuar.",
    "addBrand": "Añadir Marca",
    "all": "Todo",
    "amount": "Monto",
    "amount_paid": "Importe pagado",
    "announcements": "Anuncios",
    "any": "Cualquier",
    "applies_to": "Aplica para",
    "apply": "Aplicar",
    "apply_filters": "Aplicar filtros",
    "ascending": "Ascendiendo",
    "assignee": "Cesionario",
    "asyncExportSuccess": "Su exportación se está procesando y será enviada a {email} cuando haya terminado.",
    "attach": "Adjuntar",
    "availability": "Disponibilidad",
    "available": "Disponible",
    "balance": "Balance",
    "billing": "Facturación",
    "brand": "Marca:",
    "brands": "Marcas",
    "bulk_actions": "Acciones masivas",
    "businessIdentifier": "identificador comercial",
    "buyer": "Comprador",
    "calendar": "Calendario",
    "cancel": "Cancelar",
    "cannabinoids": "Cannabinoides",
    "case": "Caja",
    "cases": "Estuches",
    "cash": "Efectivo",
    "category": "Categoría",
    "cbd": "CBD",
    "cbda": "CBDA",
    "cbg": "CBG",
    "cbn": "CBN",
    "city": "Ciudad",
    "classification": "Clasificación",
    "clear": "Limpiar",
    "clear_filters": "Borrar filtros",
    "clear_selection": "Borrar selección",
    "close": "Cerrar",
    "closed": "Cerrado",
    "coa": "COA",
    "code": "Código",
    "color": "Color",
    "columns": "Columnas",
    "comments": "Comentarios",
    "company": "Compañía",
    "companyInformation": "Información de la empresa",
    "completedOn": "Completado el",
    "confirm": "Confirmar",
    "contact": "Contacto",
    "contacts": "Contactos",
    "continue": "Continuar",
    "cost": "Costo",
    "create": "Crear",
    "createOrder": "Crear pedido",
    "createOrderLegacy": "Crear pedido (legado)",
    "created": "Creado",
    "created_by": "Creado por",
    "created_date": "Fecha de creación",
    "created_on": "Creado el",
    "creating": "Creando",
    "csvTemplate": "Plantilla CSV",
    "currentlyUnavailable": "No disponible actualmente",
    "customMenu": "Menú personalizado",
    "customer": "Cliente",
    "customerCount": "0 Clientes | {count} Cliente | {count} Clientes",
    "customers": "Clientes",
    "date": "Fecha",
    "deactivated": "Desactivado",
    "delete": "Borrar",
    "deleteImage": "Eliminar imagen",
    "deliveryPreferences": "Preferencias de entrega",
    "descending": "Descendiendo",
    "description": "Descripción",
    "dialogs": {
      "confirm_removal": "¿Está seguro de que desea eliminar esto?"
    },
    "discount": "Descuento",
    "discountAmountOff": "{amount} de descuento",
    "discount_type": "Tipo de descuento",
    "discounts": "Descuentos",
    "dontShowMessageAgain": "No volver a mostrar este mensaje",
    "download_all_orders": "Descargar todos los pedidos",
    "duplicate": "Duplicado",
    "edit": "Editar",
    "editBrand": "Editar Marca",
    "editOrder": "Editar pedido",
    "editOrderLegacy": "Editar pedido (legado)",
    "edit_contact": "Editar contacto",
    "edit_customer": "Editar Cliente",
    "edit_customers": "Editar clientes",
    "edit_prices": "Editar precios",
    "editing": "Editando",
    "either": "Tampoco",
    "email": "Correo",
    "empty": "vacío",
    "end_date": "Fecha de finalización",
    "errors": "Errores",
    "example": "Ejemplo",
    "exciseTax": "Impuesto al consumo",
    "export": "Exportar",
    "facebook": "Facebook",
    "false": "Falso",
    "faq": "FAQ",
    "featured": "Destacado",
    "fields": "Campos",
    "filter": "Filtro",
    "filters": "Filtros",
    "first_name": "Nombre",
    "fulfillment_queue": "Cola de cumplimiento",
    "hide": "Ocultar",
    "image": "Imagen",
    "import": "Importación",
    "importing": "Importando",
    "inactive": "Inactivo",
    "instagram": "Instagram",
    "inventory": "Inventario",
    "invoiceId": "Id. de factura",
    "invoices": "Facturas",
    "isRequired": "{field} es obligatorio",
    "is_mapped": "Se asigna",
    "items": "Artículos",
    "label": "Etiqueta",
    "last_modified": "Última modificación",
    "last_name": "Apellido",
    "learnMore": "Más información",
    "license": "Licencia",
    "licenseRequestChange": "¿Seguro que desea enviar una \"Solicitud de cambio de licencia\" sin transferir productos?\nPara transferir productos de una licencia existente, seleccione una licencia en el menú desplegable \"Transferir productos desde\".\nSi va a añadir un nuevo número de licencia, ignorar este mensaje.",
    "licenseType": "Tipo de licencia",
    "licenseNumber": "Número de Licencia",
    "licenses": "Licencias",
    "load_more": "Cargar más",
    "loading": "Cargando",
    "logIn": "Iniciar sesión",
    "logo": "logotipo",
    "make_primary_contact": "Convertir en contacto principal",
    "max": "Max",
    "message": "Message",
    "min": "Min",
    "minimum": "Mínimo",
    "modal": {
      "action": "Acción"
    },
    "modified": "Modificado",
    "more": "Más",
    "more_links": "Más enlaces",
    "name": "Nombre",
    "new": "Nuevo",
    "next": "Próximo",
    "nickname": "Alias",
    "no": "No",
    "no_minimum": "Sin Mínimo",
    "noPhone": "Sin teléfono",
    "no_results": "No hay resultados",
    "no_sales_reps": "Sin representantes de ventas",
    "no_status": "Sin estado",
    "no_value": "Sin valor",
    "none": "Ninguna",
    "not_applicable_abbr": "N/D",
    "note": "Nota",
    "notes": "Notas",
    "notifications": "Notificaciones",
    "num_available": "{num} Disponible",
    "numberSelected": {
      "product": "<strong>{ 0} productos</strong> seleccionados |<strong>{num} producto</strong> seleccionados |<strong>{num} productos</strong> seleccionados"
    },
    "number_of_total_selected": "{num} de {total} seleccionados",
    "ok": "De acuerdo",
    "okay": "Está bien",
    "onBackorder": "En pedido pendiente",
    "open": "Abierto",
    "optional": "opcional",
    "or": "O",
    "order": "Pedido",
    "order_created": "Pedido creado",
    "order_id": "Número de pedido",
    "order_minimum": "Mínimo de pedido",
    "order_sort": "Orden del pedido",
    "order_status": "Estado del pedido",
    "order_summary": "Resumen del pedido",
    "order_total": "Total del pedido",
    "orders": "Pedidos",
    "other": "Otro",
    "paid": "Pagado",
    "paid_question": "¿Pagado?",
    "payment_date": "Fecha de pago",
    "payment_type": "Tipo de pago",
    "payment_types": {
      "ach": "ACH",
      "cash": "Efectivo",
      "cashier": "Cajero",
      "cashiers_check": "Cheque de caja",
      "check": "Cheque",
      "credit": "Crédito",
      "leaflink_financial": "LeafLink Financial",
      "trade": "Comercio",
      "wire": "Transferencia",
      "wire_transfer": "Transferencia por cable"
    },
    "payments": "Pagos",
    "paymentOptions": "Opciones de Pago",
    "phone": "Teléfono",
    "phonePlaceholder": "(555) 555-5555",
    "pick_a_date": "Elegir una fecha",
    "pick_a_day": "Elige un día",
    "placeholder_sales_reps": "Seleccionar representantes de ventas",
    "position": "Posición",
    "prev": "Anterior",
    "previous_version": "Versión anterior",
    "price": "Precio",
    "print": "Imprimir",
    "product": "Producto",
    "productCount": "0 Productos | {count} Producto | {count} Productos",
    "product_line": "Línea Producto",
    "product_name": "Nombre Producto",
    "products": "Productos de la marca",
    "promotional": "Promocionales",
    "public": "Público",
    "qty_short": "Cantidad",
    "quantity": "Cantidad",
    "quantityAvailable": "Cantidad disponible",
    "readLess": "Leer menos",
    "readMore": "Leer más",
    "reason": "Razón",
    "received": "Recibido",
    "received_date": "Fecha de recepción",
    "refresh": "Refrescar",
    "reject": "Rechazar",
    "rejected": "Rechazado",
    "remove": "Quitarlo",
    "remove_contact": "Eliminar contacto",
    "request": "Pedido",
    "request_sample": "Solicitud Muestra",
    "required": "Obligatorio",
    "reserved": "Reservada",
    "reset_filters": "Limpiar",
    "review": "Revisar",
    "row": "Rema",
    "salesRep": "Representante de ventas",
    "sales_reps": "Representantes de ventas",
    "sales_reps_short": "representantes de ventas",
    "sample": "Muestra",
    "save": "Guardar",
    "saveAndClose": "Guardar y cerrar",
    "saveChanges": "Guardar cambios",
    "search": "Buscar",
    "search_term": "Término de búsqueda",
    "secondary_email": "Correo electrónico secundario",
    "secondary_phone": "Teléfono secundario",
    "seeResults": "Ver resultados",
    "selectAll": "Seleccionar todo",
    "select_all_that_match": "Seleccionar todas las búsquedas y filtros coincidentes",
    "select_item": "Seleccionar elemento",
    "select_one": "Seleccione uno",
    "seller": "Vendedor",
    "vendor": "Proveedor",
    "send": "Enviar",
    "sendMessage": "Envia mensaje",
    "service_zone": "Zona de Servicio",
    "ship_date": "Fecha de envío",
    "ship_date_modified": "Fecha de envío modificada por última vez",
    "shipping": "Envío",
    "shop_brands": "Comprar por marcas",
    "shop_products": "Comprar Productos",
    "show": "¡Muéstrame",
    "show_all": "Mostrar todo",
    "showing_num_of_total_results": "Mostrando {num} de {total} resultados",
    "skip": "Saltar",
    "sku": "SKU",
    "sku_number": "SKU: {sku}",
    "sku_quantity": "Cantidad de SKU",
    "soldBy": "Vendido por",
    "sold_by": "Vendido por",
    "sort_by": "Ordenar por",
    "source": "Origen",
    "split": "Dividir",
    "start_date": "Fecha de inicio",
    "state": "Estado",
    "status": "Estado",
    "status_question": "¿Estado?",
    "strain": "Cepa",
    "strainClassification": "Clasificación de Cepas",
    "strain_name": "Nombre de Cepa",
    "strains": "Cepas",
    "subcategory": "Subcategoría",
    "submit": "Presentar",
    "submitted": "Presentado",
    "subtotal": "Subtotal",
    "subtracted": "Sustraído",
    "tag": "Etiqueta",
    "tags": "Etiquetas",
    "task": "Tarea",
    "tasks": "Tareas",
    "tax": "Impuestos",
    "tdp": "TDP",
    "templates": "Plantillas",
    "terms": "Términos y condiciones",
    "termsOfService": "Términos de servicio",
    "territories": "Territorios",
    "thc": "THC",
    "thca": "TCA",
    "title": "Título",
    "to": "Para",
    "total": "Total",
    "totalAmount": "Importe total",
    "totalCannabinoids": "Cannabis total",
    "totalThc": "Total THC",
    "true": "Cierto",
    "twitter": "X",
    "type": "Tipo",
    "type_to_search": "Escriba para buscar",
    "unassigned": "Sin asignar",
    "unavailable": "No disponible",
    "unit": "Unidad",
    "unitNumber": "Número de unidad",
    "unitOfMeasure": "Unidad de medida",
    "unlimited": "Ilimitado",
    "unpaid": "Sin pagar",
    "update": "Actualización",
    "uploading": "Subiendo",
    "users": "Usuarios",
    "validate": "Validar   ",
    "validating": "Validando",
    "varieties": "Variedades",
    "variety": "Variedad",
    "view": "Ver",
    "viewDocument": "Ver Documento",
    "viewing": "Mirando",
    "warning": "Advertencia",
    "website": "Sitio Web",
    "websitePlaceholder": "https://www.ejemplo.com",
    "yes": "Sí",
    "youtube": "YouTube",
    "zipcode": "Código Postal",
    "zipcodes": "Códigos postales",
    "zone": "Zona"
  },
  "constants": {
    "activation_statuses": {
      "active": "Activo",
      "inactive": "Inactivo"
    },
    "credit_reasons": {
      "other": "Otro",
      "promo_existing_customer": "Promoción - Cliente existente",
      "promo_new_customer": "Promoción - Nuevo cliente",
      "return_defective": "Devolución - Defectuoso",
      "return_expired": "Devolución - Expirado",
      "return_order_issue": "Devolución - Problema pedido",
      "return_other": "Devolución - Otro",
      "return_packaging": "Devolución - Embalaje"
    },
    "credit_statuses": {
      "active": "Activo",
      "cancelled": "Cancelado",
      "used": "Usado"
    },
    "leadInfo": {
      "itemAddedToCart": "Producto añadido al carrito",
      "itemViewed": "Producto visto",
      "menuViewed": "Menú visto"
    },
    "returnStatuses": {
      "cancelled": "Cancelada",
      "complete": "Completa",
      "submitted": "Presentada"
    },
    "taskStatuses": {
      "done": "Terminado",
      "inProgress": "En curso",
      "todo": "Para hacer"
    }
  },
  "layout": {
    "companyStatus": {
      "companyNotLive": "{company} no está activa todavía.",
      "companyNotLiveTooltip": "Parece que su cuenta aún no está al aire en LeafLink. ¡Ponte en contacto con tu Client Experience Manager para salir al aire la venta y conseguir tus productos delante de los minoristas en LeafLink!",
      "currentlyManaging": "Actualmente gestionando {company}",
      "updateLicenses": "Envíenos sus licencias actualizadas"
    },
    "sideNav": {
      "adminTools": "Herramientas de administración",
      "customers": "Clientes",
      "dashboard": "Panel",
      "discoverProducts": "Descubrir productos",
      "fulfillment": "Cumplimiento",
      "inventory": "Inventario",
      "messages": "Mensajes",
      "orderDeliveries": "Entregas del pedido",
      "orders": "Pedidos",
      "payments": "Pagos",
      "previewMenu": "Vista previa del menú",
      "purchasingInsights": "Información sobre compras",
      "reports": "Informes",
      "salesDashboard": "Tablero de ventas",
      "settings": "Configuración",
      "shipping": "Envío",
      "shopBrands": "Comprar por marcas",
      "shopProducts": "Comprar productos"
    },
    "userProfile": {
      "logout": "Cerrar Sesión",
      "manageProfile": "Administrar Perfil",
      "referRetailer": "Recomienda a un minorista, gana $50",
      "releaseNotes": "Notas de Publicación",
      "shareLeafLink": "Compartir LeafLink",
      "shareMenu": {
        "dialog": {
          "selectLicenseType": {
            "description": "Seleccione la licencia que desea simular para el menú descargado. Esto garantiza que los productos que se muestran a los usuarios coincidan con las licencias que pueden comprar.",
            "selectBuyerLicenseType": "Seleccione el tipo de licencia de comprador"
          }
        },
        "emailModal": {
          "downloadPDF": "Descargar PDF",
          "existingCustomers": "Clientes existentes",
          "exampleEmail": "Correo electrónico de ejemplo",
          "goToMenuLink": "Ir al enlace del menú",
          "goToOrderForm": "Ir al formulario de pedido",
          "hey": "Hola",
          "message": "Mensaje",
          "recipient": "Destinatario",
          "recipients": "Destinatarios",
          "submitShareMenu": "Compartir menú",
          "submitShareOrderForm": "Compartir Formulario de Pedido",
          "title": "Compartir menú por correo electrónico",
          "titleOrderForm": "Compartir formulario de pedido por correo electrónico",
          "yourMessagePlaceholder": "tu mensaje irá aquí"
        },
        "linkText": "Menú para compartir",
        "modal": {
          "description": {
            "leafLinkUsers": "Los usuarios de LeafLink serán dirigidos a la experiencia del menú de marca iniciada y navegarán a través del proceso de pedido estándar.",
            "nonLeafLinkUsers": "Los usuarios que no sean de LeafLink pueden acceder a su menú público y deben registrarse para realizar pedidos. De manera predeterminada, los menús públicos no muestran precios, cantidades disponibles ni productos internos. Para actualizar la configuración de su menú público, visite Configuración.",
            "orderFormLeafLinkUsers": "Los usuarios ingresados serán dirigidos a la experiencia de la Orden de Formulario nueva.",
            "orderFormNonLeafLinkUsers": "Los usuarios desconectados deben verificar su identidad para ver la experiencia de la Orden de Formulario nueva.",
            "settings": "Elige qué información quieres mostrar en tu menú personalizado"
          },
          "disclaimer": "Al compartir este enlace de menú, usted reconoce que LeafLink no verifica el estado de la licencia ni las credenciales comerciales de cualquier minorista que no haya iniciado sesión en una cuenta de LeafLink. Es su responsabilidad verificar la información del minorista antes de la entrega, cumplir con la legislación aplicable y cualquier uso no autorizado o abuso del enlace.",
          "title": "Menú para compartir",
          "labels": {
            "availableProductQuantities": "Cantidades de producto disponibles",
            "brandBanner": "Banner de marca",
            "brandLogo": "Logotipo de la marca",
            "brandTaglineDescription": "Lema y descripción de la marca",
            "buyerLicenseType": "Tipo de licencia de comprador",
            "contactInfo": "Información de contacto",
            "createOrderForm": "Crear formulario de pedido",
            "defaultMenu": "Menú predeterminado",
            "howDoOrderFormLinksWork": "¿Cómo funcionan los enlaces del formulario de pedido?",
            "howDoLinksWork": "¿Cómo funcionan los enlaces del menú?",
            "leafLinkUsers": "Usuarios de LeafLink",
            "menuSettings": "Configuración del menú",
            "menuType": "Tipo de menú",
            "nonLeafLinkUsers": "Usuarios que no son de LeafLink",
            "otherWaysToShare": "Other ways to share",
            "orderForm": "Formulario de Pedido",
            "orderFormLeafLinkUsers": "Usuarios de LeafLink ingresados",
            "orderFormNonLeafLinkUsers": "Usuarios de LeafLink desconectados",
            "productImages": "Imágenes de productos",
            "selectMenuToShare": "Seleccione el menú para compartir",
            "shareViaMenuLink": "Compartir a través del enlace del menú"
          }
        },
        "successDownloadModal": {
          "description": "Un menú en PDF ha sido enviado al correo electrónico asociado con tu cuenta de LeafLink.",
          "headline": "Descarga de PDF Iniciada",
          "timeToDownload": "Por favor, espera hasta 5 minutos para que llegue a tu bandeja de entrada.",
          "title": "Descargar Menú"
        },
        "successEmailModal": {
          "description": "Se ha enviado un enlace a su menú digital y una copia del menú en PDF a su(s) destinatario(s).",
          "descriptionOrderForm": "Se ha enviado un enlace a su formulario de pedido a su(s) destinatario(s).",
          "headline": "Su menú se ha compartido con éxito",
          "headlineOrderForm": "Tu formulario de pedido se ha compartido con éxito",
          "timeToArrival": "Por favor, espere hasta 5 minutos para que llegue a su bandeja de entrada."
        }
      }
    }
  },
  "legacy": {
    "accounting": {
      "archived_question": "¿Archivado?",
      "clear_mapping": "Borrar asignación",
      "clear_mapping_success": "Se borró correctamente la asignación.",
      "create_on_quickbooks": "Crear en QuickBooks",
      "custom_fields": "Campos personalizados",
      "customer_mapping": "Asignación Cliente",
      "customer_name": "Nombre Cliente",
      "customer_not_mapped_to_quickbooks": "El cliente {name} de este pedido aún no se ha asignado a un cliente de QuickBooks. Seleccione el cliente de QuickBooks al que desea asignar.",
      "discount_account": "Cuenta de descuento",
      "fetch_order_line_items_error": "Este pedido no tiene ninguna línea de pedido. Agregue una línea de pedido antes de empujar a Quickbooks.",
      "map_invoice_before_push": "Debe asignar estos recursos antes de que se pueda insertar la factura.",
      "parent_product_question": "¿Producto Padre?",
      "product_mapping": "Mapeo de Producto",
      "push_invoice": "Factura Añadir",
      "pushed_to_quickbooks_success": "Se ha enviado correctamente pedido '{number}' para '{company}' a QuickBooks.",
      "pushing_invoice_to_quickbooks": "Empujar factura a QuickBooks",
      "quickbooks": "QuickBooks",
      "quickbooks_customer": "Cliente de QuickBooks",
      "quickbooks_item": "Elemento de QuickBooks",
      "resources_mapped_to_quickbooks": "Todos los recursos se han asignado a QuickBooks. Puede añadir la factura ahora.",
      "unmapped_customer": "Cliente sin asignar",
      "update_discount_account": "Cuenta de descuento actualizada correctamente."
    },
    "attach": "Adjuntar",
    "connected": "Conexo",
    "connected_to_metrc_item": "Conectado a un elemento Metrc",
    "create_customer_in_quickbooks": "Crear Cliente en QuickBooks",
    "create_non_inventory_product_confirmation": "Esto creará un nuevo producto que no sea de inventario en QuickBooks. El tipo de producto y otros detalles se pueden editar en QuickBooks después de la creación.",
    "create_quickbooks_item": "Crear elemento en QuickBooks",
    "customers": {
      "account_delinquency": "Delincuencia de Cuenta",
      "add_activity": "Agregar Actividad",
      "add_contact": "Añadir Contacto",
      "add_customer_status": "Agregar estado del Cliente",
      "add_customer_status_heading": "Agregar nuevo estado del Cliente",
      "add_existing_contact_to_customer": "Agregar un Contacto existente a este Cliente",
      "all_accounts": "Todas las cuentas",
      "archive_customer": "Archivar Cliente",
      "archive_customer_confirm": "¿Está seguro de que desea archivar '{customer}'?",
      "archive_customer_error": "No se puede archivar el cliente '{customer}'.",
      "archive_customer_success": "cliente archivado '{customer}'.",
      "associate_contact_success": "{name} asociado a este cliente.",
      "back_to_contact_picker": "Volver a Selector de Contacto",
      "check_archived_records_question": "¿Comprobar registros archivados?",
      "choose_existing_contact": "Elija un Contacto existente para agregar",
      "contacts": "Contactos",
      "create_contact": "Crear Contacto",
      "create_contact_error": "Error al crear contacto.",
      "create_contact_success": "{name} contacto creado.",
      "create_customer_status_success": "Se ha creado el estado del Cliente.",
      "create_new_contact_for_customer": "Crear un nuevo Contacto para este Cliente",
      "create_new_contact_heading": "Crear un nuevo Contacto",
      "customer_has_leaflink_account": "Este cliente tiene una cuenta en LeafLink.",
      "customer_has_no_leaflink_account": "Este cliente no tiene una cuenta en LeafLink.",
      "customer_is_archived": "Este cliente está actualmente archivado.",
      "customer_list_search_placeholder": "Buscar nombre, número Licencia, estado, etiquetas o representante de ventas",
      "customer_status_name": "Nombre del estado del cliente",
      "customer_status_placeholder": "Por ejemplo, Prospect",
      "customer_tier": "Nivel Cliente",
      "delete_customer_status_confirm": "¿Está seguro de que desea eliminar este estado personalizado? Esta acción no es reversible.",
      "delinquent": "Delincuente",
      "downloading": "Descarga de CRM. Tenga en cuenta que los filtros de esta página se reflejan en el archivo adjunto.",
      "edit_customer_status_heading": "Editar nuevo estado del Cliente",
      "export_crm": "Descargar CRM",
      "fetch_all_contacts_error": "No se pudieron buscar contactos.",
      "fetch_customer_contacts_error": "No se pudieron recuperar los contactos del cliente.",
      "fetch_customers_error": "No se han podido recuperar clientes.",
      "fetch_service_zones_error": "No se pueden recuperar las zonas de servicio.",
      "fetch_statuses_error": "No se pueden obtener los estados de CRM del cliente.",
      "good_standing": "En Buen Estado",
      "license_type_placeholder": "Por ejemplo, recreativo",
      "loading_customers": "Cargando clientes",
      "make_contact_primary_error": "Error al establecer contacto como principal",
      "make_contact_primary_success": "Contacto establecido como principal",
      "modify_status_permission_error": "No tienes permiso para modificar {name}.",
      "next_contact_date": "Fecha del siguiente contacto",
      "no_custom_statuses_created": "No ha creado ningún estado personalizado.",
      "no_date_set": "Sin fecha establecida",
      "no_zone": "Sin Zona",
      "pick_sales_rep": "Seleccionar un representante de ventas",
      "reassign": "Reasignar",
      "remove_contact_confirm": "¿Estás seguro de que deseas eliminar '{name}' como contacto para este cliente?",
      "search_error": "No se puede realizar la búsqueda",
      "select_contact": "Seleccione un Contacto",
      "service_zones_search_placeholder": "Buscar zonas de servicio",
      "set_status_cleared": "{company} estado borrado.",
      "set_status_success": "{company} estado establecido en '{state}'",
      "show_archived_results": "Mostrar resultados de búsqueda archivados",
      "showing_num_results": "mostrando {num} resultados",
      "specify_state_order": "Especifique el pedido de este estado. Donde 1 es el comienzo de su embudo de ventas. Por ejemplo, un estado «Llamado en frío» podría ser un 1.",
      "state_placeholder": "es decir. Colorado o CO",
      "status_color": "Color de estado",
      "tier_num": "Nivel {num}",
      "transfer_data": "Transferir datos",
      "unarchive": "Desarchivar",
      "unarchive_customer_error": "No se puede establecer el cliente '{customer}' como activo.",
      "unarchive_customer_success": "Cliente '{customer}' configurado como activo.",
      "unlink_contact_error": "No se pudo desasociar el contacto del cliente.",
      "unlink_contact_success": "{name} relación eliminada.",
      "update_contact_date_error": "No se pudo actualizar la fecha del siguiente contacto",
      "update_contact_date_success": "Fecha del siguiente contacto actualizada",
      "update_customer_status": "Actualizar estado del Cliente",
      "update_sales_reps_error": "No se pudieron actualizar los representantes de ventas.",
      "update_sales_reps_success": "Representantes de ventas actualizados."
    },
    "deliveries": {
      "acquire_date": "Fecha de Adquirir",
      "acquire_type": "Adquirir tipo",
      "assigned_date": "Fecha asignada",
      "assigned_from_date": "Fecha de origen asignada",
      "assigned_to_date": "Fecha asignada",
      "created_from_date": "Fecha de creación a partir de",
      "created_to_date": "Fecha de creación",
      "delivery_info__acquire_date_from": "Adquirido de",
      "delivery_info__acquire_date_to": "Adquirido a",
      "edit_notes_modal_title": "Editar nota para pedido {number}",
      "fetch_customers_error": "No se pudo buscar clientes para filtrar",
      "fetch_deliveries_error": "Se ha producido un problema al buscar tus entregas.",
      "fetch_sellers_error": "No se han podido buscar vendedores para filtrar",
      "fetch_statuses_error": "No se pudieron obtener estados para filtrar",
      "manifest_number": "Número de manifiesto",
      "sellers": "Vendedores",
      "ship_date_modified": "Fecha de envío modificada después de",
      "ship_from_date": "Fecha de origen de envío",
      "ship_to_date": "Fecha de Envío",
      "update_status_failure": "No se pudo establecer {attribute}.",
      "update_status_success": "{attribute} actualizado correctamente."
    },
    "draft_orders": {
      "backordered_question": "¿Pedido en espera?",
      "last_edited_by": "Última edición por",
      "order_submit_error": "Error al enviar pedido {id}",
      "order_submit_success": "Pedido enviado correctamente {id}",
      "owner": "Propietario",
      "search_by_customers": "Buscar por clientes",
      "search_by_last_edited": "Buscar por usuario editado por última vez",
      "submit_order": "Enviar pedido"
    },
    "expense_account": "Cuenta de gastos",
    "fetch_brands_error": "No se pudo buscar marcas.",
    "fetch_company_data_error": "Error al cargar los datos de la empresa.",
    "fetch_company_licenses_error": "Error al recuperar las licencias de la empresa.",
    "fetch_license_types_error": "No se pudieron obtener los tipos de licencia.",
    "fetch_product_lines_error": "Error al cargar líneas de producto.",
    "fetch_products_error": "No se han podido obtener productos.",
    "fetch_quickbooks_items_error": "Error al recuperar elementos de QuickBooks.",
    "fetch_sales_reps_error": "No se pudo recuperar a los miembros del personal de la empresa.",
    "fulfillment": {
      "all_checkboxes_required": "Debes hacer clic en todas las casillas de verificación anteriores para poder hacer clic en el botón «Cumplir pedido»",
      "attach_package": "Adjuntar Paquete",
      "comment_meta_data": "Por: {author} en {date}",
      "connect_product_to_metrc": "Conectar Producto a Metrc",
      "connected_metrc_item": "Elemento de metrc conectado",
      "fulfill_order": "Cumplir pedido",
      "fulfill_order_error": "Error al gestionar pedido {id}: {errors}",
      "fulfill_order_success": "Pedido {id} completado correctamente",
      "load_fulfillment_queue_error": "Error al cargar la cola de cumplimiento.",
      "load_order_comments_error": "Error al cargar los comentarios del pedido.",
      "load_sales_reps_error": "Error al cargar representantes de ventas.",
      "load_service_zones_error": "Error al cargar zonas de servicio.",
      "loading_comments": "Cargando comentarios",
      "metrc_connected_question": "¿Conectado con Metrc?",
      "no_order_comments": "No hay comentarios para este pedido.",
      "packed_question": "¿Empacado?",
      "remove_package_error": "Error al eliminar el paquete.",
      "ship_order": "Una vez marcado como enviado, el estado de un pedido solo puede revertirse a ser gestionado por un administrador de su cuenta de LeafLink. Pulse OK para continuar o Cancelar para volver.",
      "summary": "A continuación se muestran los pedidos <strong>aceptados</strong> listos para ser cumplidos.",
      "unlinked_package": "Desvincular Paquete"
    },
    "general_request_error": "Se ha producido un problema con su solicitud. Inténtelo de nuevo o póngase en contacto con el soporte técnico.",
    "income_account": "Cuenta de ingresos",
    "inventory": {
      "reconcile_inventory": "Reconciliar Inventario",
      "strains": {
        "add_strain": "Añadir Cepa",
        "empty_strains": "No has creado cepas.",
        "update_strain": "Actualizar Cepa"
      }
    },
    "invoice_pdf": "PDF de factura",
    "last_payment_date": "Fecha del último pago",
    "load_company_error": "Error al cargar la compañía.",
    "load_draft_orders_error": "Error al cargar la lista de borradores de pedidos.",
    "load_line_items_error": "Error al cargar artículos de línea.",
    "load_packages_error": "Error al cargar paquetes.",
    "load_products_error": "Error al cargar productos.",
    "manage_territories": {
      "create_territories": "Crear territorios",
      "delete_territory": "Eliminar territorio",
      "delete_territory_confirm": "¿Está seguro de que desea eliminar este territorio?",
      "delete_territory_error": "Error al eliminar el territorio.",
      "delete_territory_success": "Se ha eliminado correctamente el territorio.",
      "fetch_company_territories_error": "Error al recuperar los territorios actuales de la empresa.",
      "no_territories_exist": "No has creado ningún territorio.",
      "shipping_price": "Precio de envío",
      "update_all_territories_error": "Error al actualizar todos los territorios.",
      "update_all_territories_success": "Territorios actualizados.",
      "update_territories_error": "Error al actualizar territorios."
    },
    "manual_orders": {
      "create_order_error": "No se ha podido pP crear pedido.",
      "discount_decimal_error": "Los descuentos sólo pueden tener hasta dos decimales.",
      "discount_minimum_error": "Los valores de descuento deben ser mayores que 0.",
      "discount_range_error": "Los porcentajes de descuento deben estar entre 0 y 100.",
      "fetch_order_error": "No se pudo obtener el pedido.",
      "fetch_remaining_products_error": "No se pudieron recuperar los productos restantes.",
      "insufficient_inventory_error": "No hay suficiente inventario disponible para la compra. Si estás intentando añadir un producto en pedido pendiente, crea un nuevo pedido con el artículo y márcalo como pedido pendiente.",
      "quantity_fraction_error": "Este producto no admite cantidades fraccionarias",
      "quantity_insufficient_error": "No hay suficiente inventario disponible",
      "quantity_minimum_error": "Debe ser mayor que 0",
      "sale_price_limit_error": "Precio de venta debe ser menor que el precio al por mayor",
      "submit_order_error": "No se ha podido enviar pedido."
    },
    "markpaid_input_helper": "Puedes introducir números negativos para créditos, reembolsos o pagos rebotados.",
    "med": "Medicinal",
    "metrc_item": "Artículo Metrc",
    "metrc_package": "Paquete Metrc",
    "new_package_tag": "Etiqueta de paquete nuevo",
    "not_connected": "No conectado",
    "order_entered_by_seller": "Este pedido fue ingresado por el vendedor en nombre del comprador.",
    "order_has_existing_balance": "Este pedido tiene un saldo existente de {balance}.",
    "order_has_special_requests": "Este pedido tiene peticiones especiales.",
    "order_id": "Número de pedido",
    "order_invoice": {
      "attach_documents": "Adjuntar documentos",
      "back_to_order_deliveries": "Volver a las entregas pedido",
      "back_to_orders_received": "Volver a pedidos recibidos",
      "back_to_orders_sent": "Volver a pedidos enviados",
      "back_to_shipping_queue": "Volver a cola de envío",
      "batch_id": "Id. de En Lote",
      "cancel_order_confirm": "¿Está seguro de que desea cancelar este pedido?",
      "cancelling_order": "Cancelación de pedido",
      "change_order_status": "Cambiar estado del pedido",
      "click_to_resolve": "Haga clic aquí para resolver.",
      "contact_buyer": "Contactar al comprador",
      "contact_seller": "Contactar al vendedor",
      "create_invoice_success": "Factura creada.",
      "credits": "Créditos",
      "delete_draft": "Eliminar borrador",
      "delete_draft_order_confirm": "¿Está seguro de que desea eliminar este borrador de pedido? Esta acción es permanente y elimina el pedido, las líneas de pedido y los mensajes, notas o detalles asociados a ella.",
      "deleting_order": "Eliminación de pedido",
      "directions": "Indicaciones",
      "draft_state_inventory_warning": "¡Atención! pedidos en estado <strong>Borrador</strong> no modifican el inventario ni las cantidades disponibles.",
      "edit_batch": "Editar En Lote",
      "edit_batch_error": "Error al cambiar el Id. de En Lote.",
      "edit_batch_success": "Se ha cambiado correctamente el ID del lote.",
      "edit_delivery_provider_details": "Editar detalles del proveedor de entrega confiable",
      "edit_order_confirm_title": "Edición de un pedido {state}",
      "edit_order_in_state_confirm": "Estás a punto de editar un pedido en el estado '{state}'. <br/><br/><strong>Cambiar los importes de inventario para pedidos en el estado '{state}' no actualizará automáticamente tu Inventario o las cantidades disponibles para reflejar estos cambios y debe realizarse manualmente. <br/><br/>Para asegurarse de que se actualiza el inventario, vuelva a devolver el estado del pedido al estado Aceptado y realice cualquier modificación .</strong> <br/><br/>¿ Está seguro de que desea continuar?",
      "edit_sales_representatives": "Editar representantes de ventas",
      "edit_shipping_details": "Editar detalles de envío",
      "email_invoice": "Factura por correo electrónico",
      "excise_tax_disclaimer": "A menos que se indique lo contrario, el Exento de Impuesto se debe pagar en el momento de la entrega.",
      "fetch_order_error": "Error al cargar pedido.",
      "fetch_quickbooks_customers_error": "Error al recuperar clientes de QuickBooks.",
      "hide_batch_id": "Ocultar ID de En Lote en la factura",
      "how_to_edit_per_order": "Puede cambiar esto por orden seleccionando Editar pedido en el menú Acciones en la parte superior de la página.",
      "internal_comments": "Comentarios Internos",
      "internal_order_notes": "Notas Orden Interno",
      "item_on_backorder": "¡Este artículo está en pedido pendiente!",
      "legacy_invoice": "Factura heredada",
      "load_batches_error": "Error al cargar lotes para el artículo.",
      "mark_as_paid": "Marcar como pagado",
      "messages": "Mensajes",
      "order_delivery_preferences": "Preferencias de entrega de pedidos",
      "product_list": "Lista de producto",
      "push_invoice_to_service": "Añadir factura a {name}",
      "quickbooks_token_expired": "Su token de QuickBooks expiró. <br/>Haga clic aquí para resolver.",
      "reject_order_confirm": "¿Está seguro de que desea rechazar este pedido?",
      "rejecting_order": "Rechazo de pedido",
      "repush_invoice_to_service": "Volver a enviar factura a {name}",
      "returned": "Regreso",
      "select_batch_id": "Seleccionar ID En Lote",
      "shipping_charge": "Gastos de envío",
      "shipping_details": "Detalles del envío",
      "split_attach_packages": "Dividir/Adjuntar paquetes",
      "submitting_order": "Envío del pedido",
      "submitting_order_confirm_li_1": "Los pedidos originales que se van a combinar se marcarán como <strong>Declinada</strong>",
      "submitting_order_confirm_li_2": "Sus proveedores <strong>no recibirán</strong> un correo electrónico de rechazo",
      "submitting_order_confirm_li_3": "Los productos, cantidades y precios indicados en este borrador de pedido se incluirán en el nuevo pedido",
      "submitting_order_confirm_li_4": "Parte de la información del pedido original se dejará en blanco en el nuevo pedido combinado",
      "submitting_order_confirm_li_5": "En los casos en que los precios de los producto difieran entre los pedidos, se crearán varias líneas de pedido",
      "submitting_order_confirm_note": "<strong>Tenga en cuenta</strong>que al enviar las siguientes acciones se llevarán a cabo",
      "tax_value_and_details": "El impuesto es {taxRate}. Esto incluye:<br /><br />{orderTaxes}<br />Esto excluye los artículos auxiliares y los descuentos de pedido completos. {sellerMsg}<br /><br /><strong>Nota para vendedores de CA:</strong> El CDTFA especifica que todos los descuentos durante una transacción de plena competencia deben volver a añadirse al precio imponible de todos los minoristas. Puede leer más información del CDTFA sobre el cálculo apropiado del exento de impuesto <a href=\"http://www.cdtfa.ca.gov/industry/cannabis.htm#Facts\" target=\"_blank\">aquí</a>.",
      "total_price": "Precio total",
      "total_weight": "Peso total",
      "transfers": "Transferencias",
      "unit_price": "Precio Unidad",
      "update_order_id_error": "No se pudo actualizar el número de pedido.",
      "usable_mmj": "MMJ utilizable",
      "vendor_disclaimer": "Deslinde de responsabilidad del proveedor",
      "view_order_log": "Ver registro pedido"
    },
    "order_made_through_leaflink": "Este pedido se realizó a través de LeafLink.",
    "order_notes": "Notas del pedido",
    "order_payments": {
      "add_payment": "Añadir pago",
      "amount_paid_input_helper": "Puedes introducir números negativos para créditos, reembolsos o pagos rebotados.",
      "enter_payment_amount_error": "Introduce un importe de pago.",
      "enter_payment_date_error": "Introduce una fecha de pago válida",
      "mark_order_paid_warning": "Esto marcará el pedido como Pagado.",
      "no_payments_submitted": "No se han enviado pagos para pedido {number}",
      "order_payment_history": "Historal de pagos del pedido",
      "payment_functionality_off": "No tiene activada la funcionalidad de pago de LeafLink. Contacto con support{'@'}leaflink.com para empezar!",
      "reason_placeholder": "Ingresa el motivo",
      "remaining_balance": "Saldo restante",
      "save_payment_success": "Pago guardado!",
      "submitted_by_name_date": "Enviado por: {name} en {date}"
    },
    "order_used_llf_payment": "Este marcas solicitó LeafLink Financial como pago",
    "order_was_paid": "Este pedido fue pagado.",
    "orders": {
      "loading_line_items": "Cargando artículos de línea",
      "manifest_id": "ID de manifiesto",
      "order_balance": "Saldo del pedido",
      "order_delivery_preferences": "Preferencias de entrega de pedidos",
      "order_paid_in_full": "Este pedido fue pagado en su totalidad.",
      "search_by_name": "Buscar por nombre o SKU"
    },
    "orders_received": {
      "all_orders": "Todos los pedidos",
      "classifications": {
        "adult_use": "Uso Adulto",
        "cannabis": "Cannabis",
        "combined": "Combinado",
        "medical": "Uso Medicinal",
        "none": "Sin Clasificación"
      },
      "click_to_map": "Haga clic aquí para mapear.",
      "combined_order": "Pedido combinado",
      "confirm_push_orders_to_quickbooks": "¿Está seguro de que desea añadir los siguientes pedidos a QuickBooks?",
      "connected_to_quickbooks_question": "¿Conectado a QuickBooks?",
      "create_an_order": "Crear un pedido",
      "customer_not_mapped_quickbooks": "El cliente {name} de este pedido aún no se ha asignado a un cliente de QuickBooks. Seleccione el cliente de QuickBooks al que desea asignar.",
      "customer_search_error": "Error al buscar clientes.",
      "delivered_by": "Entregado por",
      "download_all_orders": "Descargar todos los pedidos",
      "fetch_order_data_error": "No se pudieron obtener datos del pedido {number}.",
      "fetch_orders_error": "No se han podido obtener pedidos.",
      "fetch_sales_reps_for_filtering_error": "No se pudieron buscar representantes de ventas para filtrar",
      "fetch_service_zones_error": "No se pudo obtener zonas de servicio para filtrar",
      "from_date": "Fecha de origen",
      "invoice_created": "Factura creada",
      "last_seven_days": "Últimos 7 días",
      "loading_orders": "Cargando pedidos",
      "lockOrder": "Bloquear pedido",
      "lockOrderError": "El pedido {number} no puede ser cerrado. Inténtalo de nuevo.",
      "lockOrderSuccess": "El pedido {number} fue bloqueado con éxito.",
      "manual": "Generado por el vendedor",
      "no_results_found": "No se han encontrado resultados, por favor revise su ortografía o revise su búsqueda.",
      "order_already_target_status_error": "Pedido {id} ya marcado como {status}. Actualiza esta página antes de intentarlo de nuevo.",
      "order_from_delinquent_customer": "Este pedido es de un Cliente que has marcado como moroso.",
      "order_not_pushed_to_quickbooks": "Este pedido no se ha enviado a Quickbooks.",
      "order_pushed_to_quickbooks": "Este pedido fue enviado a Quickbooks.",
      "orders_with_unmapped_products_not_pushed": "Pedidos con productos no asignados o clientes no se enviarán a QuickBooks. Asigne productos y clientes antes de enviar a QuickBooks.",
      "organic": "Generado por el comprador",
      "push_invoices_to_quickbooks": "Añadir facturas a QuickBooks",
      "push_order_error": "No se pudo añadir pedido {number}: {response}",
      "push_order_success": "pedido enviado correctamente: {number}",
      "push_orders_to_quickbooks": "Añadir pedidos a QuickBooks",
      "push_to_quickbooks": "Añadir a QuickBooks",
      "reject_email": "No enviar notificación por correo electrónico al comprador",
      "reject_order": "Rechazar pedido",
      "reject_order_header": "Selecciona un motivo para rechazar este pedido e introduce cualquier nota adicional. Esta información será visible para los compradores en la página Resumen del pedido. Tenga en cuenta que rechazar un pedido NO es reversible.",
      "reject_reason": "Motivo de los rechazos",
      "search_by_customer": "Buscar por Cliente",
      "sum_on_num_orders": "<strong class=\"text-underline\">$ {sum}</strong> en <strong>{numOrders}</strong> pedidos",
      "title": "Pedidos recibidos",
      "to_date": "Hasta la fecha",
      "transition_order_status_error": "No se pudo realizar la transición del pedido {id}",
      "type_minimum_to_search": "Escriba 3 o más caracteres para buscar.",
      "unlockOrder": "Desbloquear pedido",
      "unlockOrderError": "El pedido {number} no puede ser desbloqueada. Inténtalo de nuevo.",
      "unlockOrderSuccess": "El pedido {number} fue desbloqueado exitosamente",
      "unmapped_customer": "Cliente sin asignar",
      "who_is_order_for": "¿Para cuál cliente es este pedido?"
    },
    "orders_sent": {
      "company_has_temp_licenses": "Esta empresa cuenta con licencias TEMP 2018.",
      "confirm_order_delivery_date": "Confirmar fecha de entrega del pedido",
      "delivery_confirmation_date_format_error": "La fecha de confirmación de entrega debe estar en formato AAAA-MM-DD.",
      "delivery_date_label": "¿Cuándo se recibio este pedido?",
      "markOrderAsPaid": "Marcar pedido como pago",
      "markOrderAsPaidObs": "Esto es sólo para su registro. Es posible que no coincida con el estado del pedido del vendedor.",
      "no_orders": "Sin pedidos",
      "order_has_been_received": "Este pedido ha sido recibido.",
      "order_information_saved": "Informaciones del pedido guardadas.",
      "order_not_yet_accepted": "Este pedido aún no ha sido aceptado por el vendedor.",
      "order_not_yet_received": "Este pedido aún no se ha recibido.",
      "order_under_company_minimum": "Este pedido está bajo el pedido mínimo de su empresa de {minimum}",
      "received_question": "¿Recibido?",
      "remove_delivery_confirmation_question": "¿Eliminar confirmación de entrega?",
      "reorder": "Repedidoe"
    },
    "payment_submit_error": "Se ha producido un problema al enviar el pago.",
    "payment_submit_success": "Pago presentado",
    "products": {
      "archive_product_confirm": "¿Está seguro de que desea marcar este producto como Archivado?",
      "available_qty": "Disponible: {qty}",
      "change_log": "Registro de cambios",
      "clone": "Clonar",
      "company_products": "{companyName} Productos",
      "connect_metrc_items": "Conectar elementos de metrc",
      "create_product_success": "'{name}' guardado en el inventario.",
      "current_inventory": "Inventario actual",
      "dealPrice": "Precio Oferta",
      "dealsPriceDisabled": "Edita este producto y agrega un precio de oferta para destacar este producto en la campaña {campaignLabel}",
      "dealsPriceEnabled": "Este producto será destacado en la campaña {campaignLabel}",
      "delete_product_image_error": "Error al eliminar la imagen.",
      "delete_product_spec_confirm": "¿Está seguro de que desea eliminar esta especificación del producto?",
      "delete_product_spec_error": "Error al eliminar la especificación del producto.",
      "delete_product_spec_success": "Se ha eliminado la especificación '{product}'.",
      "delete_variety_error": "Error al eliminar Variedad",
      "featured_on_deals": "Destacado en Promociones de LeafLink",
      "fetch_children_error": "¡No pude ir a buscar niños!",
      "fetch_licenses_error": "No se pudo obtener licencias.",
      "fetch_listing_states_error": "No se pudieron recuperar los estados del listado.",
      "fetch_product_categories_error": "No se han podido obtener las categorías de producto.",
      "fetch_product_templates_error": "No se han podido obtener plantillas de producto.",
      "general_submission_error": "Ha habido errores con tu envío. Compruebe el formulario e inténtelo de nuevo.",
      "in_cases": "por caja",
      "inherited_inventory": "Inventario Inventario Heredado",
      "inventory_sold_in_bulk": "{unit_multiplier}x {unit_denomination} {unit_of_measure} por {sell_in_unit_of_measure}",
      "item_available_at_date": "Artículo disponible en {date}",
      "item_currently_featured": "Este artículo aparece actualmente en la lista.",
      "item_dropped_at_time": "Artículo publicado en {time}",
      "item_dropped_date": "Artículo publicado {date}",
      "leaflink_deals": "Promociones de LeafLink",
      "max_deals_reached": "Ya has seleccionado {productMax} productos de esta marca para que se promocionen en la página de promociones de leaflink de LeafLink",
      "metrcPackagesRedirect": "Los paquetes están ahora en Conciliar inventario",
      "metrc_connected_question": "¿Metrc conectado?",
      "metrc_packages": "Paquetes Metrc",
      "min_deals_discount": "El precio de venta debe tener al menos un {minDiscount}% de descuento sobre el precio mayorista para aparecer en LeafLink Promociones de LeafLink",
      "missingUnitInformation": "Sin información de unidad",
      "missingUnitInformationTooltip": "Filter by products that are missing information about what is in a unit",
      "no_batch_associated": "No hay lote asociado",
      "no_custom_strains_exist": "No ha creado ninguna cepas personalizada.",
      "no_products_found": "No se han encontrado Productos",
      "num_product_options": "{count} opciones de producto",
      "num_skus_found": "{count} SKU encontrados",
      "performance": "Desempeño",
      "product_family_has_various_states": "Esta familia de producto tiene varios estados.",
      "product_has_no_images": "Este producto no tiene imágenes. Los compradores verán el logotipo de la marca en las páginas de compras.",
      "proposed_inventory": "Inventario propuesto",
      "reserved_qty": "{qty} reservada",
      "restock": "Reabastecer",
      "restock_inventory_error": "Error al reabastecer '{name}'",
      "restock_inventory_success": "Niveles de inventario actualizados para '{name}'",
      "retail_price_msrp": "Precio al por menor (Precio Sugerido por el Fabricante)",
      "salePrice": "Precio de venta",
      "search_products_by_fields": "Buscar Productos por nombre, SKU, estado, categoría y tipo de licencia",
      "select_items_to_attach": "Seleccionar elementos para enlazar",
      "time_until_date": "Tiempo hasta {date}",
      "unit_of_measure_no_inherited_inventory_support": "Esta unidad de medida actual no funcionará con el inventario heredado.",
      "update_inventory_error": "No se ha podido actualizar el inventario del producto",
      "update_inventory_success": "Niveles de inventario actualizados",
      "update_listing_state_error": "Error al actualizar el estado del listing para '{name}'",
      "update_listing_state_success": "'{name}' establecido en {state}",
      "update_pricing_error": "Error al actualizar '{name}'",
      "update_pricing_success": "Datos actualizados de precios para '{name}'",
      "update_product_image_success": "'{name}' se ha actualizado correctamente.",
      "update_product_state_error": "No se pudo actualizar el estado del listing del producto. {error}",
      "update_product_state_general_error": "No se pudo actualizar el estado del listing de productos",
      "update_product_state_success": "Estado actualizado del listado de productos",
      "updated_date": "Actualizado: {date}",
      "upload_product_image_error": "Error al guardar la imagen. Compruebe el tamaño de la imagen (2 MB máximo).",
      "upload_product_image_success": "Se ha subido correctamente la imagen de '{name}'.",
      "wholesale_price": "Precio al por mayor"
    },
    "products_not_mapped_to_quickbooks": "Los siguientes productos LeafLink aún no se han asignado a un producto QuickBooks. Seleccione el producto QuickBooks al que desea asignar.",
    "push_order_to_quickbooks": "Añadir pedido a QuickBooks",
    "push_to_name": "Añadir a {name}",
    "repush_to_name": "Volver a presionar a {name}",
    "s2s": {
      "accepted_package_count": "Recuento de paquetes aceptados",
      "active": "Activo",
      "actual_departure": "Salida real",
      "adjustment_quantity": "Cantidad de ajuste",
      "administration_method": "Método de administración",
      "all_fields_required": "Todos los campos son obligatorios.",
      "any_testing_state": "Cualquier estado de prueba",
      "associate_transfer_error": "Error al asociar la transferencia.",
      "attach_package_error": "Error al adjuntar paquete.",
      "attach_package_success": "El paquete se adjunta al pedido.",
      "categories": "Categorías",
      "category_type": "Tipo de categoría",
      "create_package_success": "El paquete se ha creado correctamente.",
      "created": "Creado",
      "date_created": "Fecha de creación",
      "delivery_information": "Información de entrega",
      "delivery_package_count": "Número de paquetes de entrega",
      "display_on_invoice": "Mostrar en factura",
      "enter_formatted_date_error": "Introduce una fecha en formato «DD-MM-AAAA».",
      "estimated_arrival_time": "Hora de llegada Est",
      "estimated_departure": "Salida Est",
      "export_available_tags_from_metrc_dashboard": "1. Exportar «Etiquetas disponibles» desde el panel de control de Metrc",
      "facility": "Instalación",
      "fetch_adjustment_reasons_error": "Error al recuperar los motivos de ajuste.",
      "fetch_attached_transfers_error": "Error al recuperar las transferencias asociadas para este pedido.",
      "fetch_items_error": "Error al recuperar elementos.",
      "fetch_order_transfers_error": "Error al recuperar las transferencias para este pedido.",
      "fetch_transfer_associated_deliveries_error": "Error al recuperar entregas asociadas a esta transferencia.",
      "find_transfer_in_metrc_error": "No encuentro la transferencia en Metrc. Póngase en contacto con el servicio de asistencia.",
      "finish_package_error": "Error al finalizar el paquete.",
      "finish_package_success": "Este paquete ha finalizado correctamente.",
      "finished_date": "Fecha de finalización",
      "inactive": "Inactivo",
      "item_name": "Nombre del artículo",
      "lab_testing_state": "Estado de pruebas de laboratorio",
      "lab_tests": "Pruebas de laboratorio",
      "last_modified": "Última modificación",
      "last_month": "Hace un mes",
      "last_week": "La semana pasada",
      "load_dashboard_packages_error": "Error al cargar paquetes para rellenar el panel.",
      "load_delivery_packages_error": "f paquetes para esta entrega.",
      "load_item_packages_error": "Error al cargar paquetes para el artículo.",
      "load_items_error": "Error al cargar elementos.",
      "load_packages_error": "Error al cargar paquetes.",
      "load_units_of_measure_error": "Error al cargar unidades de medida.",
      "manifest": "Manifiesto",
      "manifest_number": "Número de manifiesto",
      "metrc_dashboard": "Panel de control de metrc",
      "metrc_destination_item": "Elemento de destino de metrc",
      "metrc_item_name": "Nombre del elemento de metrc",
      "metrc_items": "Elementos Metrc",
      "new_amount": "Nuevo importe",
      "new_package_amount": "Cantidad del paquete nuevo",
      "new_package_quantity": "Cantidad de paquete nuevo",
      "new_source_package_amount": "Nuevo importe del paquete de origen",
      "new_value": "Nuevo valor",
      "no_associated_products": "No se han encontrado productos asociados.",
      "no_elements_found": "¡Ups! No se han encontrado elementos. Considere cambiar la consulta de búsqueda.",
      "no_packages_found": "No se han encontrado paquetes.",
      "num_packages": "{num} Paquetes",
      "num_sign_packages": "# Paquetes",
      "num_total_packages_and_remaining": "{total} Total de paquetes, {remaining} restantes",
      "package": "Paquete",
      "package_action_confirm": "¿Estás seguro de que quieres {action} este paquete?",
      "package_date": "Fecha del paquete",
      "packaged": "Embalaje",
      "packaged_date": "Fecha de embalaje",
      "packages": "Paquetes",
      "product_and_metrc_item_association_enables": "La asociación de productos LeafLink con este artículo de Metrc le permitirá: Ver los niveles actuales de Inventario Metrc al ver el producto LeafLink y seleccionar un paquete para asociarlo a una línea de pedido de LeafLink.",
      "received_time": "Tiempo de recepción",
      "recipient": "Destinatario",
      "refresh_metrc_data_error": "Error al actualizar los datos de Metrc.",
      "refreshed_on": "Refrescado el",
      "remove_transfer_error": "Error al eliminar la transferencia.",
      "remove_transfer_success": "Se ha eliminado correctamente la transferencia de LeafLink.",
      "search_by_label_or_name": "Buscar por etiqueta de producto o nombre de producto",
      "search_for_metrc_items_by": "Buscar artículos de Metrc por nombre, categoría o cepa",
      "select_adjustment_error": "Seleccione un motivo de ajuste, paquete y fecha de ajuste.",
      "select_date_range_error": "Seleccione un intervalo de fechas válido.",
      "select_package": "Seleccionar paquete",
      "select_products": "Seleccionar Productos",
      "select_timeframe_to_sync_metrc": "Seleccione el período de tiempo para sincronizar Metrc {resourceName}",
      "select_timeframe_to_sync_metrc_info": "Seleccione el período de tiempo para sincronizar la información de Metrc",
      "serving_size": "Tamaño de la porción",
      "source_package": "Paquete de origen",
      "split_package": "Paquete dividido",
      "split_package_error": "Error al dividir el paquete.",
      "split_package_success": "Se ha dividido correctamente el paquete.",
      "submit_to_metrc": "Enviar a Metrc",
      "supply_duration_days": "Días de duración de suministro",
      "syncing_metrc_information": "Sincronización de la información de Metrc",
      "testing_state": "Estado de prueba",
      "total_quantity": "Cantidad total",
      "unfinish_package_error": "Error al anular el paquete.",
      "unfinish_package_success": "Este paquete se ha completado correctamente.",
      "unit_cbd_content": "Contenido de CBD de la unidad",
      "unit_cbd_content_unit_of_measure": "Unidad CBD unidad de medida Contenido",
      "unit_cbd_percentage": "Porcentaje de CBD por unidad",
      "unit_thc_content": "Contenido de THC de la unidad",
      "unit_thc_content_unit_of_measure": "Unidad THC Contenido unidad de medida",
      "unit_thc_percentage": "Porcentaje de THC de unidad",
      "unit_volume": "Volumen Unidad",
      "unit_weight": "Peso Unidad",
      "unit_weight_unit_of_measure": "Unidad de medida de peso Unidad",
      "update_metrc_item_error": "No se pudo actualizar el elemento de metrc.",
      "update_metrc_item_success": "Artículo actualizado.",
      "update_product_error": "Error al actualizar el producto.",
      "update_product_success": "Producto actualizado.",
      "update_products_error": "Error al actualizar todos los productos",
      "update_products_success": "Productos actualizados.",
      "updating_metrc_data_error": "Error al actualizar los datos de METRC.",
      "updating_metrc_data_warning": "Actualizando sus datos METRC, compruebe si hay actualizaciones en 10 minutos.",
      "use_code_scanner_tip": "Consejo: Puede utilizar su escáner Code CR950/CR2600 para introducir números de etiqueta."
    },
    "save_shipment_date_error": "Error al guardar la fecha de envío",
    "save_shipment_date_success": "Fecha de envío guardada",
    "service_zones": "Zonas de servicio",
    "shipping_manifest": {
      "delivery_provider": "Proveedor de entrega",
      "description": "Estás a punto de imprimir el manifiesto de envío de la factura n.º {orderId}. Puede incluir la información del conductor a continuación o simplemente saltar a imprimir.",
      "driver": "Conductor",
      "driver_phone": "Teléfono del conductor",
      "license_plate": "Licencia ícula",
      "notes": "Notas de envío",
      "title": "Manifiesto de envío",
      "vehicle_make": "Marca del vehículo",
      "vehicle_model": "Modelo de vehículo"
    },
    "source": "Origen",
    "submit_payment": "Enviar pago",
    "territories": {
      "add_new_territory": "Añadir nuevo territorio",
      "create_territory_error": "Error al crear territorio.",
      "create_territory_success": "Territorio creado correctamente.",
      "delete_territory": "Eliminar territorio",
      "delete_territory_confirm": "¿Está seguro de que desea eliminar este territorio?",
      "delete_territory_error": "Error al eliminar el territorio.",
      "delete_territory_success": "Se ha eliminado correctamente el territorio.",
      "enter_location": "Introducir ubicación",
      "fetch_company_territories_error": "Error al recuperar los territorios actuales de la empresa.",
      "fetch_state_regions_error": "Error al recuperar regiones para el estado.",
      "save_territory": "Guardar territorio",
      "update_territory_error": "Error al editar el territorio.",
      "update_territory_success": "Territorio actualizado correctamente."
    },
    "update_customer_success": "cliente actualizado correctamente.",
    "update_line_item_error": "Error al actualizar la línea de pedido.",
    "update_line_item_success": "Línea de pedido actualizada.",
    "update_product_success": "producto actualizado correctamente.",
    "use_old_create_order": "¿Prefiere la antigua página Crear pedido?",
    "view_order": "Ver pedido"
  },
  "ll": {
    "date": {
      "months": {
        "april": "abril",
        "august": "agosto",
        "december": "diciembre",
        "february": "febrero",
        "january": "enero",
        "july": "julio",
        "june": "junio",
        "march": "marzo",
        "may": "mayo",
        "november": "noviembre",
        "october": "octubre",
        "september": "septiembre"
      },
      "next_month": "El mes que viene",
      "previous_month": "Mes anterior",
      "weekdays": {
        "friday": "Vie",
        "monday": "Lu",
        "saturday": "Sáb",
        "sunday": "Sol",
        "thursday": "Ju",
        "tuesday": "Mar",
        "wednesday": "Miér"
      }
    },
    "file_upload": {
      "csv_title_inventory": "Esta importación CSV solo actualizará los niveles de inventario de producto.",
      "drag_drop_file_here": "Arrastre y suelte su archivo aquí",
      "errors": {
        "csv_title": "Se ha producido un error al importar su CSV.",
        "duplicate_product": "Entrada duplicada: {sku}",
        "incorrect_file_type": "Suelta un archivo con el tipo: {fileTypes}",
        "invalid_csv_headers": "Encabezado CSV no válido: el archivo debe incluir sólo {headers}",
        "invalid_product_total": "Valor no válido en Total: el valor de {sku} debe ser un número positivo",
        "is_not_unlimited": "Valor no válido en Total: la configuración de gestión de inventario de un producto no se puede cambiar a «ilimitado» con esta importación. Establece el valor total para {sku}",
        "is_unlimited": "Valor no válido en Total: la configuración de gestión de inventario de un producto no se puede cambiar de «ilimitado» con esta importación. El total debe permanecer «ilimitado» para {sku}",
        "missing_column": "La fila {rowNum} tiene {columnNum} columnas. Cada fila debe tener {expectedColumnNum} columnas | La fila {rowNum} solo tiene {columnNum} columna. Cada fila debe tener {expectedColumnNum} columnas | La fila {rowNum} solo tiene {columnNum} columnas. Cada fila debe tener {expectedColumnNum} columnas",
        "missing_header": "Falta el encabezado: {header}",
        "no_sku": "El SKU de la fila {rowNum} puede no estar en blanco",
        "sku_does_not_exist": "El SKU no existe en la lista de producto: {sku}"
      },
      "exportLabels": {
        "all": {
          "item": "Todos los artículos",
          "product": "Todos los productos",
          "task": "Todas las tareas"
        },
        "matchingSearchAndFilters": {
          "item": "Elementos que coinciden con tu búsqueda y filtros | {num} elementos que coinciden con tu búsqueda y filtros | {num} elementos que coinciden con tu búsqueda y filtros",
          "product": "Productos que coinciden con tu búsqueda y filtros | {num} producto que coinciden con tu búsqueda y filtros | {num} productos que coinciden con tu búsqueda y filtros",
          "task": "Tareas que coinciden con la búsqueda y filtros | {num} tareas que corresponden a su búsqueda y filtros"
        }
      },
      "export_csv": "Exportar CSV",
      "import_csv": "Importar CSV",
      "in_csv": {
        "item": "<strong>0 artículos</strong> en CSV |<strong>{num} artículo</strong> en CSV |<strong>{num} artículos</strong> en CSV",
        "product": "<strong>0 productos</strong> en CSV |<strong>{num} producto</strong> en CSV |<strong>{num} productos</strong> en CSV"
      },
      "try_again": "Inténtalo de nuevo",
      "upload_file": "Cargar archivo",
      "will_be_updated": {
        "item": "Se actualizarán<strong>0 artículos</strong> |<strong>{num} artículos</strong> se actualizarán |<strong>{num} artículos</strong> se actualizarán",
        "product": "Se actualizarán<strong>0 productos</strong> |<strong>{num} producto</strong> se actualizarán |<strong>{num} productos</strong> se actualizarán"
      }
    },
    "imageGallery": {
      "maxFileSize": "La imagen {image} excede el máximo ({max}MB) de tamaño permitido.",
      "minImageSize": "Imagen {name} no cumple con el mínimo ancho / alto ({width} / {height}) requerido."
    },
    "list_view": {
      "calculating": "Calculando resultados...",
      "name_asc": "Nombre (asc)",
      "name_desc": "Nombre (desc)"
    },
    "select": {
      "placeholder": "Seleccione la opción"
    },
    "select_panels": {
      "applied_items": "Aplicado {items}",
      "available_items": "Filtrar {items}"
    }
  },
  "mini_cart": {
    "empty_cart": "No quedan más artículos en tu carrito.",
    "proceed_to_cart": "Ir a la cesta"
  },
  "notify": {
    "errorCustomerSupport": "Hubo un error al completar la solicitud, por favor contacte a servicio al cliente.",
    "errorFetchBrands": "Error al buscar Marca Manager",
    "errorFetching": "Error obteniendo los datos",
    "errorCreateBrand": "Error al crear la marca",
    "errorUpdateBrand": "Error al actualizar la marca",
    "errorInviteManager": "Error al invitar al gerente",
    "errorCreatingStore": "Error al crear la tienda",
    "successCreatingStore": "Tienda creada con éxito"
  },
  "regions": {
    "ca": {
      "ab": "Alberta",
      "bc": "Columbia Británica",
      "mb": "Manitoba",
      "nb": "Nueva Brunswick",
      "nl": "Terranova y Labrador",
      "ns": "Nueva Escocia",
      "nt": "Territorios del Noroeste",
      "nu": "Nunavut",
      "on": "Ontario",
      "pe": "Isla del Príncipe Eduardo",
      "qc": "Québec",
      "sk": "Saskatchewan",
      "yt": "Yukón"
    },
    "countries": {
      "ca": "Canadá",
      "us": "Estados Unidos de América"
    }
  },
  "s2s": {
    "packages": "Paquetes"
  },
  "tasks": {
    "onlyOwnTasks": "Sólo mostrar mis tareas"
  },
  "trustedSeller": {
    "alerts": {
      "regainRequirement": "Recupera este requisito en {date} orden mantener tu estado."
    },
    "current": "Actual",
    "errors": {
      "generalServerError": "Se ha producido un problema al recuperar los datos del informe de estado del Vendedor. Inténtelo de nuevo o póngase en contacto con el soporte técnico.",
      "incompletePrereqError": "Debes cumplir todos los {prereq} criterios para ser {tier}.",
      "noOrdersFound": "No se han encontrado órdenes."
    },
    "factors": {
      "activeLicense": {
        "description": "Asegúrese de que su licencia de venta de cannabis actual y válida esté asociada a esta cuenta.",
        "title": "Verificación Licencia"
      },
      "avgOrganicOrdersResponseTime": {
        "description": "Los compradores aman el servicio rápido. Asegúrate de revisar los órdenes recién recibidos todos los días.",
        "stat": "Promedio de tiempo de revisión de orden {value}",
        "title": "Tiempo medio de revisión de pedidos"
      },
      "brandHasImageAndDescription": {
        "description": "Añade un logotipo de Marca y una descripción a tu menú para mejorar el conocimiento de tu marca con nuestra red de minoristas.",
        "title": "Logotipo y descripción"
      },
      "inventoryUpdated": {
        "description": "Conciliar los niveles de inventario con frecuencia para mantener la disponibilidad de los producto exacta para los compradores.",
        "stat": "{value} Actualizaciones de inventario/menú",
        "title": "Actualizaciones de disponibilidad y Producto de productos"
      },
      "orderAcceptanceRate": {
        "description": "Trabaje con los compradores para asegurarse de que se declinada acen el menor número posible de órdenes. Ayuda a aumentar la confianza del comprador en que los órdenes se cumplirán.",
        "stat": "{value} Porcentaje de aceptación de pedidos",
        "title": "Ratio Orden Aceptación de Pedidos"
      },
      "organicOrdersWithShipDate": {
        "description": "Añade fechas de envío a tus órdenes para ayudar a los compradores a comprender cuándo esperar la entrega y planificar la recepción.",
        "stat": "{value} de los órdenes tienen fechas de envío",
        "title": "Fechas de envío del pedido"
      },
      "receivedOrganicOrders": {
        "description": "Un historial de órdenes da confianza a los compradores en tu capacidad de entrega.",
        "stat": "{value} órdenes generados por el Comprador",
        "title": "Órdenes generados por el Comprador"
      }
    },
    "sellerStatus": {
      "description": "Realiza un seguimiento de tu progreso hacia la obtención de insignias de LeafLink Certified Seller para crear confianza.",
      "learnMore": "Más información",
      "statUpdates": "Estadísticas actualizadas diariamente a las 3 de la mañana.",
      "title": "Logro Certified Seller Status"
    },
    "target": "Objetivo",
    "tiers": {
      "eliteSeller": {
        "description": "Lo mejor de lo mejor en LeafLink. Los vendedores Elite ofrecen un servicio excepcional a los compradores. También debe cumplir los criterios de Power Vendedor.",
        "title": "Elite Seller"
      },
      "powerSeller": {
        "description": "Establece el estándar para vender en LeafLink. Los vendedores de energía tienen cuentas completas y proporcionan un servicio confiable a los compradores.",
        "title": "Power Seller"
      }
    },
    "units": {
      "hour": "horas"
    },
    "values": {
      "active": "Activo",
      "expired": "Caducado"
    },
    "widget": {
      "no_status_heading": "Requisitos Certified Seller",
      "status_heading": "Eres un LeafLink {status}"
    }
  },
  "validation": {
    "available": "No puede ser más de {available}",
    "betweenVal": "Debe estar entre {value}",
    "charactersRemaining": "{value} caracteres restantes",
    "duplicateFile": "Archivo duplicado",
    "einFormat": "Ingrese solo números y guiones",
    "email": "El correo electrónico debe ser válido",
    "exceededVal": "No debe exceder {value}",
    "fieldErrors": "Por favor corrija los errores del campo",
    "fractionalUnits": "Debe ser unidades enteras",
    "higherVal": "Debe ser mayor que {value}",
    "maxVal": "Debe ser como máximo {value}",
    "minVal": "Debe ser como mínimo {value}",
    "notValidTime": "Por favor ingrese una hora en formato HH:MM válido",
    "notValidValue": "No debe ser {value}",
    "onlyNumAvailable": "Solo {num} disponibles",
    "openNotBeforeClose": "La hora de apertura debe ser antes de la hora de cierre",
    "partialCases": "Por favor ordene hasta un paquete completo",
    "phone": "Se requieren 10 dígitos",
    "phoneFormats": "Por favor ingrese un número de teléfono válido. Ejemplos: 123-456-7890, 1234567890, (123) 456-7890",
    "positiveNumber": "Debe ser mayor que 0",
    "qtyUnavailable": "CANTIDAD no disponible",
    "required": "Requerido",
    "requiredAPIKey": "Por favor ingrese una clave de API",
    "requiredForLicenseType": "Requerido para tipo de licencia",
    "selectionRequired": "Selección requerida",
    "valueRequired": "Se requiere un valor",
    "wholeNumber": "Debe ser un número entero"
  }
}
